import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RxIdleUserComponent } from './rx-idle-user.component';

@NgModule({
  imports: [CommonModule, RxIdleUserComponent],
  exports: [RxIdleUserComponent],
})
export class RxIdleUserModule {}
